import { render, staticRenderFns } from "./custom-form-control.vue?vue&type=template&id=3a18563a&scoped=true&"
import script from "./custom-form-control.vue?vue&type=script&lang=js&"
export * from "./custom-form-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18563a",
  null
  
)

export default component.exports